/* =====================================================================
   EurekaPAES Buscador — Módulo Comparador + Quiz Vocacional v6
   Sub-módulos:
     EpComparador → Comparador lado a lado hasta 3 carreras favoritas
     EpQuiz       → Quiz "No sé qué estudiar"
   Expone window.EpComparador y window.EpQuiz
   ===================================================================== */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
      var v = attrs[k];
      if (v == null || v === false) continue;
      if (k === 'class') n.className = v;
      else if (k === 'text') n.textContent = v;
      else if (k === 'html') n.innerHTML = v;
      else if (k.indexOf('on') === 0 && typeof v === 'function') n.addEventListener(k.substring(2), v);
      else n.setAttribute(k, v);
    }
    if (children) {
      if (!Array.isArray(children)) children = [children];
      children.forEach(function (c) {
        if (c == null || c === false) return;
        if (typeof c === 'string') n.appendChild(document.createTextNode(c));
        else n.appendChild(c);
      });
    }
    return n;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/`/g, '&#96;');
  }
  function fmt(p) {
    if (p == null) return '—';
    return (typeof p === 'number' && p % 1 !== 0) ? p.toFixed(1) : String(p);
  }
  function dataArr() { return (window.EP_PAES_DATA && Array.isArray(window.EP_PAES_DATA)) ? window.EP_PAES_DATA : []; }
  function findByCode(cod) { var a = dataArr(); for (var i = 0; i < a.length; i++) if (a[i].codigo_demre === cod) return a[i]; return null; }
  function readJSON(k, def) { try { return JSON.parse(localStorage.getItem(k)) || def; } catch (e) { return def; } }
  function PRUEBAS_KEYS() { return ['nem','ranking','competencia_lectora','matematica_m1','matematica_m2','ciencias','historia']; }
  function labelK(k) {
    var m = {nem:'NEM',ranking:'Ranking',competencia_lectora:'CLEC',matematica_m1:'M1',matematica_m2:'M2',ciencias:'Ciencias',historia:'Historia'};
    return m[k] || k;
  }

  /* ============ COMPARADOR ============ */
  var EpComparador = (function () {
    var seleccion = []; /* códigos elegidos para comparar */

    function abrir() {
      var favs = readJSON('ep_paes_favs_v1', []);
      if (favs.length < 2) {
        alert('Necesitas al menos 2 favoritas para comparar. Marca más estrellas en las tarjetas.');
        return;
      }
      seleccion = [];
      render();
    }
    function cerrar() {
      var ov = $('#ep-paes-comp-overlay');
      if (ov) ov.remove();
    }
    function toggleSel(cod) {
      var i = seleccion.indexOf(cod);
      if (i >= 0) seleccion.splice(i, 1);
      else if (seleccion.length < 3) seleccion.push(cod);
      renderPicker();
      renderComparacion();
    }
    function render() {
      var ov = el('div', { id: 'ep-paes-comp-overlay', class: 'ep-paes-comp-overlay ep-paes-root' });
      var box = el('div', { class: 'ep-paes-comp-box' });
      box.appendChild(el('button', { type: 'button', class: 'ep-paes-comp-close', html: '✕', 'aria-label': 'Cerrar', onclick: cerrar }));
      var header = el('div', { class: 'ep-paes-dialog-header' });
      header.appendChild(el('span', { class: 'ep-paes-dialog-chip', text: 'Comparador EurekaPAES' }));
      header.appendChild(el('h2', { class: 'ep-paes-comp-title', text: 'Comparador de carreras' }));
      header.appendChild(el('p', { class: 'ep-paes-comp-sub', text: 'Compara tus favoritas y entiende cuál se adapta mejor a tus puntajes.' }));
      box.appendChild(header);
      box.appendChild(el('div', { id: 'ep-paes-comp-picker', class: 'ep-paes-comp-picker' }));
      box.appendChild(el('div', { id: 'ep-paes-comp-content', class: 'ep-paes-comp-content' }));
      ov.appendChild(box);
      ov.addEventListener('click', function (e) { if (e.target === ov) cerrar(); });
      document.body.appendChild(ov);
      renderPicker();
    }
    function renderPicker() {
      var host = $('#ep-paes-comp-picker');
      if (!host) return;
      host.innerHTML = '';
      var favs = readJSON('ep_paes_favs_v1', []).map(findByCode).filter(Boolean);
      favs.forEach(function (c) {
        var checked = seleccion.indexOf(c.codigo_demre) >= 0;
        var disabled = !checked && seleccion.length >= 3;
        var chip = el('button', {
          type: 'button',
          class: 'ep-paes-comp-chip' + (checked ? ' is-checked' : '') + (disabled ? ' is-disabled' : ''),
          onclick: function () { if (!disabled || checked) toggleSel(c.codigo_demre); }
        }, [
          el('span', { class: 'chk', html: checked ? '✓' : '+' }),
          el('span', { class: 'titulo', text: c.carrera }),
          el('span', { class: 'uni', text: c.universidad })
        ]);
        host.appendChild(chip);
      });
    }
    function computarPond(c, puntajes) {
      var pond = c.ponderaciones || {};
      var keys = Object.keys(pond).filter(function (k) { return pond[k] > 0; });
      if (keys.length === 0) return null;
      var electiva = !!c.electiva_ciencias_historia;
      var faltan = [];
      keys.forEach(function (k) { if (puntajes[k] == null || isNaN(puntajes[k])) faltan.push(k); });
      var electivaUsada = null;
      if (electiva) {
        var hasC = puntajes.ciencias != null, hasH = puntajes.historia != null;
        faltan = faltan.filter(function (k) { return k !== 'ciencias' && k !== 'historia'; });
        if (!hasC && !hasH) return null;
      }
      if (faltan.length > 0) return null;
      var total = 0;
      if (electiva) {
        var pct = pond.ciencias;
        var aC = puntajes.ciencias != null ? puntajes.ciencias * (pct / 100) : -Infinity;
        var aH = puntajes.historia != null ? puntajes.historia * (pct / 100) : -Infinity;
        if (aC >= aH) { electivaUsada = 'ciencias'; total += aC; }
        else { electivaUsada = 'historia'; total += aH; }
      }
      keys.forEach(function (k) {
        if (electiva && (k === 'ciencias' || k === 'historia')) return;
        total += puntajes[k] * (pond[k] / 100);
      });
      return { pond: Math.round(total * 10) / 10, electivaUsada: electivaUsada };
    }
    function renderComparacion() {
      var host = $('#ep-paes-comp-content');
      if (!host) return;
      host.innerHTML = '';
      if (seleccion.length < 2) {
        host.appendChild(el('div', { class: 'ep-paes-comp-hint', text: 'Selecciona al menos 2 carreras para comenzar la comparación.' }));
        return;
      }
      var carreras = seleccion.map(findByCode).filter(Boolean);
      var puntajes = readJSON('ep_paes_puntajes_v1', {});

      /* Métricas para destacar diferencias */
      var maxPond = -1, maxVac = -1, maxM1 = -1, maxCien = -1, maxRkg = -1, maxNem = -1, minDiff = Infinity;
      var iMax = {}; /* índice del max */
      carreras.forEach(function (c, i) {
        var meta = c.ponderado_ultimo_matriculado != null ? c.ponderado_ultimo_matriculado : c.puntaje_corte_clec_m1;
        if (meta != null && meta > maxPond) { maxPond = meta; iMax.pond = i; }
        if (c.vacantes != null && c.vacantes > maxVac) { maxVac = c.vacantes; iMax.vac = i; }
        var pond = c.ponderaciones || {};
        if ((pond.matematica_m1 || 0) > maxM1) { maxM1 = pond.matematica_m1 || 0; iMax.m1 = i; }
        if ((pond.ciencias || 0) > maxCien) { maxCien = pond.ciencias || 0; iMax.cien = i; }
        if ((pond.ranking || 0) > maxRkg) { maxRkg = pond.ranking || 0; iMax.rkg = i; }
        if ((pond.nem || 0) > maxNem) { maxNem = pond.nem || 0; iMax.nem = i; }
        var tu = computarPond(c, puntajes);
        if (tu && meta != null) {
          var d = meta - tu.pond;
          if (d < minDiff) { minDiff = d; iMax.cercana = i; }
        }
      });

      var grid = el('div', { class: 'ep-paes-comp-grid', 'data-n': carreras.length });
      carreras.forEach(function (c, i) {
        var col = el('div', { class: 'ep-paes-comp-col' });
        col.appendChild(el('h3', { class: 'ep-paes-comp-col-titulo', text: c.carrera }));
        col.appendChild(el('div', { class: 'ep-paes-comp-col-uni', text: c.universidad }));
        col.appendChild(el('div', { class: 'ep-paes-comp-col-meta', text: '#' + c.codigo_demre + (c.region ? ' · ' + c.region : '') + (c.sede ? ' · Sede ' + c.sede : '') }));

        var meta = c.ponderado_ultimo_matriculado != null ? c.ponderado_ultimo_matriculado : c.puntaje_corte_clec_m1;
        var tipoMeta = c.ponderado_ultimo_matriculado != null ? 'Pond.' : 'CLEC+M1';
        col.appendChild(filaComp('Puntaje meta (' + tipoMeta + ')', meta != null ? fmt(meta) : '—', iMax.pond === i, '🎯'));
        col.appendChild(filaComp('Vacantes', c.vacantes != null ? c.vacantes : '—', iMax.vac === i, '🎟️'));

        var tu = computarPond(c, puntajes);
        if (tu) {
          col.appendChild(filaComp('Tu ponderado', tu.pond, false, '🧠'));
          if (meta != null) {
            var d = Math.round((meta - tu.pond) * 10) / 10;
            col.appendChild(filaComp(d <= 0 ? 'Tu margen' : 'Te faltan', d <= 0 ? '+' + Math.abs(d) : d + ' pts', iMax.cercana === i, d <= 0 ? '✅' : '📊'));
          }
          if (tu.electivaUsada) {
            col.appendChild(filaComp('Electiva usada', tu.electivaUsada === 'ciencias' ? 'Ciencias' : 'Historia', false, '🔀'));
          }
        } else {
          col.appendChild(filaComp('Tu ponderado', 'Completa puntajes', false, '⌨️'));
        }

        /* Ponderaciones completas */
        col.appendChild(el('h4', { class: 'ep-paes-comp-col-h4', text: 'Ponderaciones' }));
        var pondTabla = el('div', { class: 'ep-paes-comp-pond' });
        PRUEBAS_KEYS().forEach(function (k) {
          var v = (c.ponderaciones || {})[k];
          if (v == null || v === 0) return;
          var row = el('div', { class: 'ep-paes-comp-pond-row' });
          row.appendChild(el('span', { class: 'lbl', text: labelK(k) }));
          var val = el('span', { class: 'val', text: v + '%' });
          /* destacar el max de M1/Ciencias/Ranking/NEM */
          if ((k === 'matematica_m1' && iMax.m1 === i && v === maxM1) ||
              (k === 'ciencias' && iMax.cien === i && v === maxCien) ||
              (k === 'ranking' && iMax.rkg === i && v === maxRkg) ||
              (k === 'nem' && iMax.nem === i && v === maxNem)) {
            val.classList.add('is-max');
          }
          row.appendChild(val);
          pondTabla.appendChild(row);
        });
        if (c.exige_mate2) pondTabla.appendChild(el('div', { class: 'ep-paes-comp-pond-row is-warn', html: '<span class="lbl">Exige M2</span><span class="val">Sí</span>' }));
        col.appendChild(pondTabla);

        col.appendChild(el('button', {
          type: 'button', class: 'ep-paes-comp-col-btn',
          text: 'Ver detalle  →',
          onclick: function () { cerrar(); if (window.EpPaesAbrirModal) window.EpPaesAbrirModal(c); }
        }));

        grid.appendChild(col);
      });
      host.appendChild(grid);

      /* Conclusiones */
      var concl = el('div', { class: 'ep-paes-comp-concl' });
      concl.appendChild(el('h4', { html: '💡 Diferencias destacadas' }));
      var ul = el('ul');
      if (iMax.pond !== undefined) ul.appendChild(el('li', { html: 'Mayor meta de puntaje: <strong>' + escapeHtml(carreras[iMax.pond].carrera) + '</strong>' }));
      if (iMax.vac !== undefined) ul.appendChild(el('li', { html: 'Mayor cantidad de vacantes: <strong>' + escapeHtml(carreras[iMax.vac].carrera) + '</strong>' }));
      if (iMax.m1 !== undefined && maxM1 > 0) ul.appendChild(el('li', { html: 'Mayor ponderación de Matemática M1: <strong>' + escapeHtml(carreras[iMax.m1].carrera) + '</strong> (' + maxM1 + '%)' }));
      if (iMax.cien !== undefined && maxCien > 0) ul.appendChild(el('li', { html: 'Mayor ponderación de Ciencias: <strong>' + escapeHtml(carreras[iMax.cien].carrera) + '</strong> (' + maxCien + '%)' }));
      if (iMax.rkg !== undefined && maxRkg > 0) ul.appendChild(el('li', { html: 'Mayor ponderación de Ranking: <strong>' + escapeHtml(carreras[iMax.rkg].carrera) + '</strong> (' + maxRkg + '%)' }));
      if (iMax.cercana !== undefined) ul.appendChild(el('li', { html: '🎯 Carrera más cercana a tus puntajes: <strong>' + escapeHtml(carreras[iMax.cercana].carrera) + '</strong>' }));
      concl.appendChild(ul);
      host.appendChild(concl);
    }
    function filaComp(label, val, highlight, icon) {
      return el('div', { class: 'ep-paes-comp-row' + (highlight ? ' is-best' : '') }, [
        el('span', { class: 'lbl', text: (icon || '') + ' ' + label }),
        el('span', { class: 'val', text: String(val) })
      ]);
    }
    function refresh() {
      if ($('#ep-paes-comp-overlay')) {
        renderPicker();
        renderComparacion();
      }
    }
    return { abrir: abrir, cerrar: cerrar, refresh: refresh };
  })();

  /* ============ QUIZ "No sé qué estudiar" ============ */
  var EpQuiz = (function () {
    var PREGUNTAS = [
      {
        q: '¿Qué tipo de problemas disfrutas más?',
        opt: [
          { t: 'Resolver problemas lógicos o matemáticos', tag: ['tec','ciencias'] },
          { t: 'Ayudar o cuidar a otras personas', tag: ['salud','social','educacion'] },
          { t: 'Crear cosas (arte, diseño, espacios)', tag: ['arte'] },
          { t: 'Investigar y entender por qué pasan las cosas', tag: ['ciencias','social'] },
          { t: 'Comunicar, escribir, persuadir', tag: ['hum','derecho','com'] }
        ]
      },
      {
        q: '¿Qué te gusta más en el colegio?',
        opt: [
          { t: 'Matemática', tag: ['tec','ciencias','adm'] },
          { t: 'Ciencias (Biología, Química, Física)', tag: ['salud','ciencias','tec'] },
          { t: 'Lenguaje, Historia, Filosofía', tag: ['hum','derecho','social'] },
          { t: 'Arte, Música, Diseño', tag: ['arte'] },
          { t: 'Todas un poco', tag: ['social','hum'] }
        ]
      },
      {
        q: '¿Con qué te imaginas trabajando?',
        opt: [
          { t: 'Personas (pacientes, estudiantes, clientes)', tag: ['salud','educacion','social'] },
          { t: 'Datos, números, modelos', tag: ['tec','adm','ciencias'] },
          { t: 'Máquinas, tecnología, software', tag: ['tec'] },
          { t: 'Naturaleza, plantas, animales, ambiente', tag: ['agro','ciencias','salud'] },
          { t: 'Ideas, palabras, contenido', tag: ['hum','com','derecho'] }
        ]
      },
      {
        q: '¿Prefieres una carrera con mucha matemática?',
        opt: [
          { t: 'Sí, me gusta', tag: ['tec','ciencias','adm'] },
          { t: 'Algo, pero no demasiado', tag: ['salud','social'] },
          { t: 'Prefiero evitarla', tag: ['hum','arte','derecho','com'] }
        ]
      },
      {
        q: '¿Te llama más?',
        opt: [
          { t: 'Trabajar en hospital o clínica', tag: ['salud'] },
          { t: 'Trabajar en empresa o emprender', tag: ['adm','tec'] },
          { t: 'Trabajar en colegio o universidad', tag: ['educacion'] },
          { t: 'Trabajar en oficina jurídica/política', tag: ['derecho','social'] },
          { t: 'Trabajar de forma creativa o independiente', tag: ['arte','com','hum'] }
        ]
      },
      {
        q: '¿Te interesa la ciencia experimental o teórica?',
        opt: [
          { t: 'Sí, mucho', tag: ['ciencias','salud','tec'] },
          { t: 'No es lo mío', tag: ['hum','derecho','com','arte','adm'] }
        ]
      },
      {
        q: '¿Estás dispuesto a estudiar fuera de tu región?',
        opt: [
          { t: 'Sí, sin problema', tag: [] },
          { t: 'Prefiero quedarme cerca', tag: [] }
        ]
      }
    ];
    /* Mapeo tag → Área SIES (oficial) */
    var TAG_TO_AREA = {
      'tec': 'Tecnología',
      'ciencias': 'Ciencias Básicas',
      'salud': 'Salud',
      'social': 'Ciencias Sociales',
      'educacion': 'Educación',
      'arte': 'Arte y Arquitectura',
      'hum': 'Humanidades',
      'derecho': 'Derecho',
      'agro': 'Agropecuaria',
      'adm': 'Administración y Comercio',
      'com': 'Humanidades'  /* Comunicación cae en Hum */
    };
    var paso = 0;
    var respuestas = [];

    function abrir() {
      paso = 0;
      respuestas = [];
      render();
    }
    function cerrar() {
      var ov = $('#ep-paes-quiz-overlay');
      if (ov) ov.remove();
    }
    function render() {
      cerrar();
      var ov = el('div', { id: 'ep-paes-quiz-overlay', class: 'ep-paes-quiz-overlay ep-paes-root' });
      var box = el('div', { class: 'ep-paes-quiz-box' });
      box.appendChild(el('button', { type: 'button', class: 'ep-paes-quiz-close', html: '✕', 'aria-label': 'Cerrar', onclick: cerrar }));
      var header = el('div', { class: 'ep-paes-dialog-header' });
      header.appendChild(el('span', { class: 'ep-paes-dialog-chip', text: 'Orientación EurekaPAES' }));
      header.appendChild(el('h2', { class: 'ep-paes-dialog-title', text: 'No sé qué estudiar' }));
      header.appendChild(el('p', { class: 'ep-paes-dialog-sub', text: 'Responde unas preguntas rápidas y descubre áreas que podrían calzar contigo.' }));
      box.appendChild(header);
      if (paso < PREGUNTAS.length) renderPregunta(box);
      else renderResultado(box);
      ov.appendChild(box);
      ov.addEventListener('click', function (e) { if (e.target === ov) cerrar(); });
      document.body.appendChild(ov);
    }
    function renderPregunta(box) {
      var pp = PREGUNTAS[paso];
      box.appendChild(el('div', { class: 'ep-paes-quiz-progress', text: 'Pregunta ' + (paso + 1) + ' de ' + PREGUNTAS.length }));
      box.appendChild(el('div', { class: 'ep-paes-quiz-bar' }, [el('i', { style: 'width:' + ((paso / PREGUNTAS.length) * 100) + '%' })]));
      box.appendChild(el('h2', { class: 'ep-paes-quiz-q', text: pp.q }));
      var opts = el('div', { class: 'ep-paes-quiz-opts' });
      pp.opt.forEach(function (o) {
        opts.appendChild(el('button', {
          type: 'button', class: 'ep-paes-quiz-opt', text: o.t,
          onclick: function () {
            respuestas.push(o.tag);
            paso++;
            render();
          }
        }));
      });
      box.appendChild(opts);
      if (paso > 0) {
        box.appendChild(el('button', {
          type: 'button', class: 'ep-paes-quiz-back', text: '← Volver',
          onclick: function () { paso--; respuestas.pop(); render(); }
        }));
      }
    }
    function renderResultado(box) {
      /* Contar tags */
      var counts = {};
      respuestas.forEach(function (tags) {
        tags.forEach(function (t) { counts[t] = (counts[t] || 0) + 1; });
      });
      /* Top 3 áreas */
      var tagsOrder = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
      var areasReco = [];
      tagsOrder.forEach(function (t) {
        var a = TAG_TO_AREA[t];
        if (a && areasReco.indexOf(a) < 0) areasReco.push(a);
      });
      areasReco = areasReco.slice(0, 3);

      box.appendChild(el('h2', { class: 'ep-paes-quiz-title', html: '✨ Tu perfil sugiere:' }));
      if (!areasReco.length) {
        box.appendChild(el('p', { text: 'No pudimos detectar áreas claras. Prueba a explorar el buscador con distintas áreas para descubrir.' }));
        box.appendChild(el('button', { type: 'button', class: 'ep-paes-quiz-go', text: 'Cerrar', onclick: cerrar }));
        return;
      }
      var areasBox = el('div', { class: 'ep-paes-quiz-areas' });
      areasReco.forEach(function (a) {
        areasBox.appendChild(el('span', { class: 'ep-paes-quiz-area-pill', text: a }));
      });
      box.appendChild(areasBox);
      box.appendChild(el('p', { class: 'ep-paes-quiz-sub', text: 'Estas son carreras representativas de tus áreas top:' }));

      /* Buscar ejemplos de carreras */
      var all = dataArr();
      var ejemplos = [];
      areasReco.forEach(function (area) {
        var matches = all.filter(function (c) { return c.area === area && (c.ponderado_ultimo_matriculado || c.puntaje_corte_clec_m1); });
        /* Tomar 4 representativas: variar puntaje */
        matches.sort(function (a, b) {
          var ma = a.ponderado_ultimo_matriculado || a.puntaje_corte_clec_m1 || 0;
          var mb = b.ponderado_ultimo_matriculado || b.puntaje_corte_clec_m1 || 0;
          return mb - ma;
        });
        ejemplos.push({ area: area, lista: matches.slice(0, 4) });
      });
      var listEl = el('div', { class: 'ep-paes-quiz-resultados' });
      ejemplos.forEach(function (g) {
        listEl.appendChild(el('h4', { text: g.area }));
        g.lista.forEach(function (c) {
          var meta = c.ponderado_ultimo_matriculado || c.puntaje_corte_clec_m1;
          var card = el('div', { class: 'ep-paes-quiz-result-card' });
          card.appendChild(el('div', { class: 'tit' }, [
            el('span', { class: 'tit-c', text: c.carrera }),
            el('span', { class: 'tit-u', text: c.universidad })
          ]));
          card.appendChild(el('div', { class: 'pts', text: meta != null ? fmt(meta) + ' pts' : '' }));
          card.appendChild(el('div', { class: 'acts' }, [
            el('button', {
              type: 'button', class: 'ep-paes-quiz-result-btn',
              text: 'Ver →',
              onclick: function () { cerrar(); if (window.EpPaesAbrirModal) window.EpPaesAbrirModal(c); }
            }),
            el('button', {
              type: 'button', class: 'ep-paes-quiz-result-btn is-fav',
              html: '☆ Guardar',
              onclick: function () {
                var fav = readJSON('ep_paes_favs_v1', []);
                if (fav.indexOf(c.codigo_demre) < 0) {
                  fav.push(c.codigo_demre);
                  localStorage.setItem('ep_paes_favs_v1', JSON.stringify(fav));
                  this.innerHTML = '★ Guardada';
                  if (window.EpFavs) {
                    if (window.EpFavs.render) window.EpFavs.render();
                    if (window.EpFavs.refreshAllStarsInDOM) window.EpFavs.refreshAllStarsInDOM();
                  }
                }
              }
            })
          ]));
          listEl.appendChild(card);
        });
      });
      box.appendChild(listEl);
      box.appendChild(el('div', { class: 'ep-paes-quiz-actions' }, [
        el('button', { type: 'button', class: 'ep-paes-quiz-back', text: '← Volver a empezar', onclick: function () { paso = 0; respuestas = []; render(); } }),
        el('button', { type: 'button', class: 'ep-paes-quiz-go', text: 'Cerrar y explorar', onclick: cerrar })
      ]));
    }
    return { abrir: abrir };
  })();

  /* ============ EXPORT ============ */
  window.EpComparador = EpComparador;
  window.EpQuiz = EpQuiz;
})();
